import DapDSBadge from './badge.component'

export * from './badge.component'
export default DapDSBadge

DapDSBadge.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-badge': DapDSBadge
  }
}
